import styled from 'styled-components';
import { EmptyButton, getTheme } from 'mol-ui';

export const DownloadCancel = styled.div`
    color: ${ getTheme('primaryColor') };
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    text-decoration: none;
`;

export const DownloadContainer = styled.div`
    border-bottom: 1px solid ${ getTheme('disabledColor') };
    padding: 15px 15px 10px 15px;
    .download-button {
        color: ${ getTheme('primaryColor') };
        display: inline-block;
        font-size: 14px;
        text-decoration: none;
    }
`;

export const DownloadPrepare = styled(EmptyButton)`
    color: ${ getTheme('primaryColor') };
    display: inline-block;
    font-size: 14px;
`;
